import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=562c9ea0&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('562c9ea0', component.options)
    } else {
      api.reload('562c9ea0', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=562c9ea0&", function () {
      api.rerender('562c9ea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/CategoryItem.vue"
export default component.exports